module.exports = __webpack_public_path__ + "static/media/frankSpinner.ef1282fc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/frankSpinner.svg
// module id = 834
// module chunks = 0